module.exports = __webpack_public_path__ + "img/Shops.f500f657.jpg";